import React, {ChangeEvent, FormEvent} from "react";
import Layout from "../components/layout";
import Axios, {AxiosResponse} from "axios";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import "./demo-request.css";

interface DemoFormState {
	company: string;
	title: string;
	nameSurname: string;
	phone: string;
	email: string;
	forSonik: boolean;
	forSonid: boolean;
	forSonis: boolean;
	note: string;
	error: string;
	submitting: boolean;
	modal: boolean;
}

type StringFields = "company" | "title" | "nameSurname" | "phone" | "email" | "note";
type BooleanFields = "forSonik" | "forSonis" | "forSonid";

class DemoForm extends React.Component<{}, DemoFormState> {

	constructor(props: {}) {
		super(props);
		this.state = {
			company: "",
			title: "",
			nameSurname: "",
			phone: "",
			email: "",
			forSonik: false,
			forSonis: false,
			forSonid: false,
			note: "",
			error: "",
			submitting: false,
			modal: false
		}
	}

	renderInput(field: StringFields, title: string, id: string) {
		return (
			<div className="form-group">
				<label htmlFor={id}>{title}</label>
				<input type="text" id={id} className="form-control" value={this.state[field]} readOnly={this.state.submitting}
					   onChange={(e) => this.inputTextChanged(e, field)}/>
			</div>
		)
	}

	inputTextChanged(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, field: StringFields) {
		const state: any = {
			[field]: e.target.value
		};
		this.setState(state);
	}

	renderCheckbox(field: BooleanFields, title: string, id: string) {
		return (
			<div className="form-group form-check form-check-inline">
				<input type="checkbox" id={id} className="form-check-input" checked={this.state[field]} readOnly={this.state.submitting}
					   onChange={(e) => this.checkboxChanged(e, field)}/>
				<label className="form-check-label" htmlFor={id}>{title}</label>
			</div>
		)
	}

	checkboxChanged(e: ChangeEvent<HTMLInputElement>, field: BooleanFields) {
		const state: any = {
			[field]: e.target.checked
		};
		this.setState(state);
	}

	submit(e: FormEvent<HTMLFormElement>) {
		e.preventDefault();

		if (!this.state.company || !this.state.nameSurname || !this.state.phone || !this.state.email) {
			this.setState({
				error: "Please fill all the required fields."
			});
		}
		else if (!this.state.forSonik && !this.state.forSonid && !this.state.forSonis) {
			this.setState({
				error: "You should choose at least one module for the demo."
			});
		}
		else {
			this.setState({
				error: ""
			});
			this.requestDemo();
		}
	}

	private async requestDemo() {
		this.setState({
			submitting: true
		});

		const modules: string[] = [];
		this.state.forSonik && modules.push("SONIK");
		this.state.forSonid && modules.push("SONID");
		this.state.forSonis && modules.push("SONIS");

		const response: AxiosResponse<any> = await Axios.post<any>("https://07tzfn8vmb.execute-api.eu-west-1.amazonaws.com/prod/mail", {
			subject: 'Sono GRC demo isteği',
			body: `<!DOCTYPE html PUBLIC>
<html>
<head>
  <style>
    td {
      padding: 5px;
      border-top: 1px solid #c6c8ca;
      border-Bottom: 1px solid #c6c8ca;
    }
    tr + tr td {
      border-top: none;
    }
  </style>
</head>
<body>
  <table>
  <tbody>
    <tr>
      <td>Kurum Adı</td>
      <td>:</td>
      <td>${this.state.company}</td>
    </tr>
    <tr>
      <td>Ünvan</td>
      <td>:</td>
      <td>${this.state.title}</td>
    </tr>
    <tr>
      <td>Ad Soyad</td>
      <td>:</td>
      <td>${this.state.nameSurname}</td>
    </tr>
    <tr>
      <td>Telefon</td>
      <td>:</td>
      <td>${this.state.phone}</td>
    </tr>
    <tr>
      <td>E-Posta</td>
      <td>:</td>
      <td>${this.state.email}</td>
    </tr>
    <tr>
      <td>Demo istediği modüller</td>
      <td>:</td>
      <td>${modules.join(", ")}</td>
    </tr>
    <tr>
      <td>Ek Açıklama</td>
      <td>:</td>
      <td>${this.state.note}</td>
    </tr>
  </tbody>
  </table>
</body>
</html>`
		});

		if (response.status === 200) {
			this.toggleModal();
		}
		else {
			this.setState({
				error: "Your demo request could not be send.",
				submitting: false
			})
		}
	}

	toggleModal() {
		if (this.state.modal) {
			this.setState({
				company: "",
				title: "",
				nameSurname: "",
				phone: "",
				email: "",
				forSonik: false,
				forSonis: false,
				forSonid: false,
				note: "",
				error: "",
				submitting: false,
				modal: false
			})
		}
		else {
			this.setState({
				error: "",
				submitting: false,
				modal: true
			})
		}
	}

	render() {
		return (
			<div className="content container">
				<h1><span>SONO</span> Demo Request Form</h1>
				<form id="demo-form" onSubmit={(e) => this.submit(e)}>
					{this.renderInput("company", "Company Name", "kurumAdi")}
					<div className="form-row">
						<div className="col-12 col-md-6">
							{this.renderInput("title", "Title", "unvan")}
						</div>
						<div className="col-12 col-md-6">
							{this.renderInput("nameSurname", "Name Surname", "adsoyad")}
						</div>
					</div>
					<div className="form-row">
						<div className="col-12 col-md-6">
							{this.renderInput("phone", "Telephone", "telefon")}
						</div>
						<div className="col-12 col-md-6">
							{this.renderInput("email", "E-Mail", "email")}
						</div>
					</div>
					<div className="form-group mb-0">
						<label className="w-100">Moduls</label>
						{this.renderCheckbox("forSonik", "Internal Control and Risk Management", "sonikModule")}
						{this.renderCheckbox("forSonid", "Internal Audit", "sonidModule")}
						{this.renderCheckbox("forSonis", "Strategic Planning", "sonisModule")}
					</div>
					<div className="form-group">
						<label htmlFor="aciklama">More</label>
						<textarea className="form-control" id="aciklama" rows={5} value={this.state.note} readOnly={this.state.submitting}
								  onChange={(e) => this.inputTextChanged(e, "note")}/>
					</div>
					{this.state.error && (
						<div className="alert-area">
							<div className="alert alert-danger">{this.state.error}</div>
						</div>
					)}
					<div className="action">
						<button className="sono-button" type="submit" disabled={this.state.submitting}>
							Send<i><i className={`fas ${this.state.submitting ? "fa-spinner fa-pulse" : "fa-chevron-right"}`}/></i>
						</button>
					</div>
				</form>

				<Modal isOpen={this.state.modal} toggle={() => this.toggleModal()}>
					<ModalHeader toggle={() => this.toggleModal()}>
						Demo Request
					</ModalHeader>
					<ModalBody>
						<p>Dear {this.state.nameSurname},</p>
						<p>We have received your demo request and will contact you promptly.Thank you for your interest in our products.</p>
						<p>SONO Software</p>
					</ModalBody>
					<ModalFooter>
						<button className="sono-button" onClick={() => this.toggleModal()}>
							OK<i className="fas fa-check"/>
						</button>
					</ModalFooter>
				</Modal>
			</div>
		);
	}

}

export default () => (
	<Layout
		pageTitle="SONO GRC - Request Demo"
		className="demo-form"
		header={
			<React.Fragment>
				<DemoForm/>

				<div className="info">
					<i className="fas"/>
				</div>
			</React.Fragment>
		}
	/>
);